import { render, staticRenderFns } from "./Firmador.vue?vue&type=template&id=e58f4a46"
import script from "./Firmador.vue?vue&type=script&lang=js"
export * from "./Firmador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e58f4a46')) {
      api.createRecord('e58f4a46', component.options)
    } else {
      api.reload('e58f4a46', component.options)
    }
    module.hot.accept("./Firmador.vue?vue&type=template&id=e58f4a46", function () {
      api.rerender('e58f4a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/perfil/Firmador.vue"
export default component.exports